import React from "react";
import HeaderComponent from "../commonComponent/HeaderComponent";
import ButtonComponent from "../commonComponent/ButtonComponent";
function NotFound() {
  return (
    <div>
      <HeaderComponent
        Title="Netpad.click"
        padding={"p-[10px_15px]"}
        onClick={() => {
          window.location = "/";
        }}
      />
      <div className="flex min-h-screen justify-center bg-page px-4 py-12 text-center font-montserrat text-text sm:px-6 lg:px-8">
        <div className="flex flex-col max-w-md w-full space-y-4 items-center">
          <h2 className="mt-6 w-full rounded-md border-2 border-primary p-2 text-left font-montserrat text-xl font-extrabold text-text shadow-xl outline-none">
            404 - PAGE NOT FOUND
          </h2>
          <div className="flex flex-row m-0 p-0 mt-0 justify-start items-start w-full gap-2 pl-5">
            <ButtonComponent
              buttonName=""
              tone="warning"
            />
            <ButtonComponent
              buttonName=""
              tone="primary"
            />
            <ButtonComponent
              buttonName=""
              tone="success"
            />
            <ButtonComponent
              buttonName=""
              tone="danger"
            />
          </div>

          <div className="flex h-1/4 flex-col items-center justify-evenly gap-4 rounded-md bg-surface shadow-lg">
            <p className="mt-2 text-center text-md text-text-muted">
              The page you are looking for does not exist. Please check the URL
              or return to the homepage.
            </p>
            <button
              className="group relative flex justify-center rounded-md border border-transparent bg-primary px-4 py-2 text-md font-[500] text-on-primary shadow-md hover:bg-primary-hover focus:outline-white focus:ring-2 focus:ring-white focus:ring-offset-2"
              onClick={() => {
                window.location = "/";
              }}
            >
              Create a Note
            </button>
          </div>
        </div>
      </div>
      <footer className="fixed inset-x-0 bottom-0 z-10 border-t border-border bg-surface font-sen">
        <div className="flex justify-center items-center p-1">
          <p className="text-text-muted text-md">
            © 2023{" "}
            <mark className="bg-inherit text-primary">Netpad.click.</mark> All
            rights reserved.{" "}
            <a
              href="mailto:communications@netpad.click"
              target="_blank"
              rel="noreferrer"
              className="text-primary underline"
            >
              Mail
            </a>
          </p>
        </div>
      </footer>
    </div>
  );
}

export default NotFound;
